import { createReducer, on } from "@ngrx/store";
import AutoArchiveRuleRow from "src/app/model/auto-archive/AutoArchiveRuleRow";
import * as AutoArchiveActions from "./auto-archive.actions";

// --- STATE STRUCTURE ---

export interface AutoArchiveState {
    rules: AutoArchiveRuleRow[];
    loading: boolean;
    error: string | null;
}

const initialAutoArchiveState: AutoArchiveState = {
    rules: [],
    loading: false,
    error: null,
};

// --- REDUCER ---

export const autoArchiveReducer = createReducer(
    initialAutoArchiveState,

    on(AutoArchiveActions.loadRules, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(AutoArchiveActions.loadRulesSuccess, (state, { rules }) => ({
        ...state,
        rules,
        loading: false,
        error: null,
    })),

    on(AutoArchiveActions.loadRulesFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    on(AutoArchiveActions.createRule, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(AutoArchiveActions.createRuleSuccess, (state, { rule }) => ({
        ...state,
        rules: [...state.rules, rule],
        loading: false,
        error: null,
    })),

    on(AutoArchiveActions.createRuleFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    on(AutoArchiveActions.updateRule, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(AutoArchiveActions.updateRuleSuccess, (state, { rule }) => ({
        ...state,
        rules: state.rules.map((r) => (r.id === rule.id ? rule : r)),
        loading: false,
        error: null,
    })),

    on(AutoArchiveActions.updateRuleFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    on(AutoArchiveActions.deleteRule, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(AutoArchiveActions.deleteRuleSuccess, (state, { id }) => ({
        ...state,
        rules: state.rules.filter((r) => r.id !== id),
        loading: false,
        error: null,
    })),

    on(AutoArchiveActions.deleteRuleFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    }))
);

export const getAutoArchiveState = (state: AutoArchiveState) => state;
